import React from "react";
import { Form, Input, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faMinusCircle } from "@fortawesome/free-solid-svg-icons";

const CustomInputNumber = ({
  name,
  label,
  min = 0,
  max = 9,
  defaultValue = 1,
  form,
}) => {
  return (
    <div className="flex flex-col w-full">
      {label}
      <div
        className="flex items-center  px-2 py-1 w-full rounded-[12px] max-w-[110px]"
        style={{ border: "1px solid #d9d9d9" }}
      >
        <Button
          className="mr-1 border-0 p-0 "
          style={{ width: "10px", height: "10px" }}
          onClick={() => {
            const currentVal = form.getFieldValue(name);
            if (currentVal > min) {
              form.setFieldsValue({
                [name]: currentVal - 1,
              });
            }
          }}
        >
          <FontAwesomeIcon icon={faMinusCircle} color="#8b92a5" />
        </Button>

        <Form.Item
          className="mb-0 grow"
          name={name}
          initialValue={defaultValue}
        >
          <Input
            type="number"
            min={min}
            max={max}
            className="text-center text-[15px] font-semibold"
            value={form.getFieldValue(name)}
            variant="borderless"
          />
        </Form.Item>

        <Button
          className="ml-1 border-0 p-0 "
          style={{ width: "10px", height: "10px" }}
          onClick={() => {
            const currentVal = form.getFieldValue(name);
            if (currentVal < max) {
              form.setFieldsValue({
                [name]: currentVal + 1,
              });
            }
          }}
        >
          <FontAwesomeIcon icon={faPlusCircle} color="#8b92a5" />
        </Button>
      </div>
    </div>
  );
};

export default CustomInputNumber;
